import { createFileRoute } from '@tanstack/react-router'
import { DashboardPage } from '@features/admin/dashboard'

export const Route = createFileRoute('/admin/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <DashboardPage />
}
